import { GET_SUPPLIER_DETAILS, GET_SUPPLIERS } from './ApiConstants';
import api from './ApiHandler';

export const getSupplierDetails = async () => {
  return await api.get(GET_SUPPLIER_DETAILS);
};

export const getSuppliersByPage = async (payload: any) => {
  return await api.get(GET_SUPPLIERS, { params: payload });
};
